import { EChartsOption } from "echarts-for-react";
import React from "react";
import { OrganizationImpactSection } from "@hpo/client/models/Archive";
import EChart from "@hpo/client/utilities/Echart";
import Print from "@hpo/client/utilities/print/Print";

type OrganizationImpactProps = {
  payload: OrganizationImpactSection;
};

export default function OrganizationImpact(props: OrganizationImpactProps) {
  const section = props.payload;

  const option: EChartsOption = {
    xAxis: {
      type: "category",
      data: section.periods,
    },
    yAxis: {
      type: "value",
      min: 0,
      splitLine: { show: true },
    },
    grid: {
      show: true,
    },
    series: [
      ...section.byOrganization.map((org) => ({
        name: org.label,
        type: "line",
        data: section.periods.map((p) => org.data[p]),
        itemStyle: { color: org.color },
        lineStyle: { color: org.color, width: 1 },
        symbol: "circle",
        symbolSize: 16,
        label: {
          show: true,
          position: "right", // Position au-dessus du point
          distance: 2,
          fontSize: 10,
        },
      })),
      {
        name: "Tous",
        data: section.periods.map((p) => section.data[p]),
        type: "line",
        itemStyle: { color: "#000000" },
        lineStyle: { color: "#000000", width: 3 },
        symbol: "circle",
        symbolSize: 16,
        label: {
          show: true,
          position: "right", // Position au-dessus du point
          distance: 2,
          fontSize: 10,
        },
      },
    ],
  };

  return (
    <div>
      <Print.PageBreak />
      <h2>{section.title}</h2>
      <EChart option={option} height={500} />
    </div>
  );
}
